import { type FC } from 'react';

import { memoWithDisplayName } from '@/packages/utils';

import { AdFoxBanner } from '../AdfoxBanner';
import { AdfoxContextProvider, type AdfoxContextProviderProps } from '../AdfoxContext';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'between_offers',
  place__DEPRECATED: 'offersSerp',
  name__DEPRECATED: 'Listing_native_TGB',
  extra__DEPRECATED: {
    offerType: 'TGB_banner',
  },
};
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 376 };
const NARROW_SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 352 };
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'ddcfw', p2: 'fkhj' };

type AdfoxTGBBannerProps = {
  serverData: AdfoxContextProviderProps['serverData'];
  position: number;
  isNarrow: boolean;
};

export const AdfoxTGBBanner: FC<AdfoxTGBBannerProps> = memoWithDisplayName(({ serverData, position, isNarrow }) => {
  return (
    <AdfoxContextProvider
      pParams={P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
      serverData={serverData}
      size={isNarrow ? NARROW_SIZE : SIZE}
    >
      <AdFoxBanner position={position} />
    </AdfoxContextProvider>
  );
}, 'AdfoxTGBBanner');
